import { render, staticRenderFns } from "./emailSetting.vue?vue&type=template&id=6610f6ac&scoped=true&"
import script from "./emailSetting.vue?vue&type=script&lang=js&"
export * from "./emailSetting.vue?vue&type=script&lang=js&"
import style0 from "./emailSetting.vue?vue&type=style&index=0&id=6610f6ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6610f6ac",
  null
  
)

export default component.exports